import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowUpRight, BookOpen } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FALLBACK = [
  {
    id: "wp-001",
    type: "Whitepaper",
    title: "The Bharat Decade: Architecting Inclusive Growth Through 2035",
    excerpt:
      "A strategic framework for translating demographic dividend into durable national capability.",
    category: "Nation Building",
    read_time: "18 min",
    date: "Feb 2026",
  },
];

export const ThoughtLeadership = () => {
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/insights`)
      .then((res) => {
        if (active && res.data?.items) setItems(res.data.items);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="bg-canvas py-28 md:py-40 scroll-mt-nav"
    >
      <div className="container-bharat">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <p className="overline">Thought Leadership</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-navy mt-6 leading-[1.02] tracking-tight">
              The Bharat Axis{" "}
              <span className="italic text-gold">Quarterly</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-graphite/70 leading-relaxed">
            Whitepapers, strategy notes and policy commentary on the
            institutional questions shaping India's growth — written for
            decision-makers, not headlines.
          </p>
        </div>

        <div className="hairline mb-10" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-graphite/10">
          {items.map((it, i) => (
            <motion.article
              key={it.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="bg-canvas hover:bg-white p-8 lg:p-10 group transition-colors duration-500"
              data-testid={`insight-${it.id}`}
            >
              <div className="flex items-center justify-between mb-8">
                <span className="overline text-graphite/50 text-[0.65rem] flex items-center gap-2">
                  <BookOpen size={12} /> {it.type}
                </span>
                <span className="text-xs text-graphite/40 font-display tracking-[0.25em]">
                  {it.category}
                </span>
              </div>
              <h3 className="font-serif-display text-2xl md:text-[1.65rem] leading-[1.15] text-navy">
                {it.title}
              </h3>
              <p className="mt-5 text-sm text-graphite/65 leading-relaxed">
                {it.excerpt}
              </p>
              <div className="mt-10 flex items-center justify-between text-xs">
                <span className="text-graphite/55">
                  {it.date} · {it.read_time} read
                </span>
                <span className="inline-flex items-center gap-2 text-navy group-hover:text-gold transition-colors">
                  Read paper
                  <ArrowUpRight
                    size={14}
                    className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThoughtLeadership;
